module.exports = __webpack_public_path__ + "files/dd9ef8b2154f3c669b474f4a41491a67.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people-4.png
// module id = 1457
// module chunks = 60